"use client";
import {
  authClient,
  type BetterAuthClientOnErrorContext,
} from "@cartz/auth/client";
import postLogout from "@/app/actions";
import { resetPylonChat } from "@/app/providers/pylon-provider";
import { confirmLeaveIfNeeded } from "@/utils/editor-unsaved-guard";
import { Button } from "./ui/button";
import { resetMerchantAnalytics } from "@/lib/analytics/client";

export const logout = async (returnTo?: string) => {
  if (!(await confirmLeaveIfNeeded())) {
    return;
  }

  await authClient.signOut({
    fetchOptions: {
      onRequest: () => {
        console.log("signing out request");
      },
      onError: (error: BetterAuthClientOnErrorContext) => {
        console.error("signing out error", error);
      },
      onSuccess: async () => {
        console.log("signing out success");
        resetMerchantAnalytics();
        resetPylonChat();
        await postLogout(returnTo);
      },
    },
  });
};

export const LogoutButton = () => {
  return <Button onClick={() => void logout()}>Logout</Button>;
};
